<template>
  <RadioButton
    @input="selectCourierDelivery"
    :value="value"
    :option="option"
    class="rd-card mt-10 heading-4 weight-medium"
    title='By Courier'
    :checked="selected">
    <template v-slot:info>
      <p class="body-3 mt-5">
        You can sign the application form delivered by courier using a digital pen device.
      </p>
    </template>
    <template v-slot:default>
      <div>
        <InfoBox class="mt-5 ib-warning" :icon="require('@/assets/svg/alert-icon.svg')">
          <p class="m-0 pr-md-5 weight-regular body-3">
            
    <b>How does it work?</b>
    <ul class="p-0">
        <li>
            After completing the online application, we will send you a unique 6-digit PIN code via e-mail and SMS.
        </li>
        <li>
            A courier will contact you within 5 business days regarding the free delivery of your application.
        </li>
        <li>
            When you receive your application, the courier will ask you for the PIN code mentioned above, which will unlock the application form.
        </li>
        <li>
            The courier will then ask you to sign it using a digital pen.
        </li>
        <li>
            Once signed, the application will be automatically processed, and you will be notified by e-mail.
        </li>
    </ul>
  
          </p>
        </InfoBox>
        <h4 class="weight-medium mt-10">
          Deliver the application form to:
        </h4>

        <AddressCard class="mt-10">
          <p>{{ `${delivery.deliveryAddress.street} ${delivery.deliveryAddress.streetNumber}`}}</p>
          <p>{{ `${delivery.deliveryAddress.zip} ${delivery.deliveryAddress.city}` }}</p>
          <p>Slovak Republic</p>
        </AddressCard>

        <h4 class="weight-medium mt-10">
          Contact details for the courier:
        </h4>
        <div class="input-box-holder mt-10" v-validate="errors" v-has-value="delivery.phone">
          <TextField
            class="input-box"
            title='Phone Number'
            description='Required Format +421 911 111 111'
            v-phone-format
            @change="setPhoneNumber"
            :value="delivery.phone"
            :max-length="16"
            required
          />
          <div class="validation-output text-left mt-1">
            <ErrorHandler class="error" id="V328">
              Enter your phone number.
            </ErrorHandler>

            <ErrorHandler class="error" id="V329">
              Enter the phone number in the correct format.
            </ErrorHandler>
          </div>
        </div>

        <div v-if="personsWithRequiredAttachmentsForCourier.length">
          <FileLoader
            v-for="(personWithAttachments, index) in personsWithRequiredAttachmentsForCourier"
            :key="index"
            :type="AttachmentTypeEnum.KOPIA_DOKLADU_TOTOZNOSTI.name$"
            :person-index="personWithAttachments.personIndex"
            :model="model"
            :errors="errors"
            class="my-10"
          >
            <div>
              <h3 class="heading-3 weight-medium pb-5 pb-md-15 text-left text-md-center">
                Copy of Identity Document
              </h3>

              <p class="body-2 weight-regular pb-10 pb-md-15 text-left">
                
    To complete the application, please upload a copy of your ID. A copy of your ID is a mandatory
    document for persons with permanent residence in the EU, not in the Slovak Republic.
  
              </p>
            </div>

            <template slot="errorLabel">
              Upload a Copy of Your ID
            </template>
          </FileLoader>
        </div>
      </div>
    </template>
  </RadioButton>
</template>
<script>
import RadioButton from '@/components/RadioButton/RadioButton.vue';
import enums from '@/mixins/enums';
import distributionChannels from '@/mixins/distributionChannels';
import persons from '@/mixins/persons';
import AddressCard from '@/components/AddressCard/AddressCard.vue';
import InfoBox from '@/components/InfoBox/InfoBox.vue';
import FileLoader from '@/components/FileLoader/FileLoader.vue';
import TextField from '@/components/TextField/TextField.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';

export default {
  name: 'CourierDeliveryComponent',
  components: {
    FileLoader,
    InfoBox,
    AddressCard,
    TextField,
    RadioButton,
    ErrorHandler,
  },
  mixins: [enums, distributionChannels, persons],
  props: {
    value: { type: Object, required: false },
    option: { type: Object, required: true },
    delivery: { type: Object, required: true },
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
    selected: { type: Boolean, required: false, default: false },
  },
  methods: {
    selectCourierDelivery(value) {
      this.$emit('input', value);
    },
    setPhoneNumber(phone) {
      this.model.delivery.phone = phone.trim().replace(/\s+/g, ' ');
    },
  },
  computed: {
    AttachmentTypeEnum() { return this.$kotlin.attachments.AttachmentTypeEnum; },
    isCallcentrumBroker() {
      return this.model.broker.callcentrumBroker;
    },
    showPhoneWithoutEdit() {
      return !this.isVIP || !this.isCallcentrumBroker;
    },
  },
  created() {
    if (!this.model.isMobile) {
      this.delivery.eSignatureDevice = this.enums.DeviceEnum.ON_ANOTHER_DEVICE;
    }
  },
};
</script>
